<template>
  <div class="view live" data-name="live">
    <LiveContent />
    <FakeImages :imageOne="'/static/img/live_hero1.jpg'" :imageTwo="'/static/img/live_hero2.jpg'" />
    <PageHero :title="'Live.'" :text="''" />
  </div>
</template>

<script>
import PageHero from '@/components/heros/PageHero.vue';
import LiveContent from '@/components/contents/LiveContent.vue';
import FakeImages from '@/components/contents/FakeImages.vue';

export default {
  name: 'live',

  components: {
    PageHero,
    LiveContent,
    FakeImages,
  },
};
</script>
